module.exports = __webpack_public_path__ + "img/1492757756.6fa53a4b.jpg";